import React from 'react';

/** Lightweight inline spinner for buttons and status cards. */
const Spinner = ({ size = 'md', onBrand = false }) => (
  <span
    className={[
      'spinner',
      size === 'lg' ? 'spinnerLg' : '',
      onBrand ? 'spinnerOnBrand' : '',
    ]
      .filter(Boolean)
      .join(' ')}
    role="status"
    aria-label="Loading"
  />
);

export default Spinner;
